import React from "react";
import styles from "../../../components/Favorite/Favorite.scss";
import { AdListFavoriteDataI } from "../../../typings/routesTypes";

interface FavoriteIconProps {
  handleFavorite: () => void;
  ad: AdListFavoriteDataI;
}

const FAVORITE_COLOR = "#F94144";

export const FavoriteIcon = ({ handleFavorite, ad }: FavoriteIconProps): JSX.Element => {
  const isFavorite = !!(ad && ad.isFavorite);

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={ad && handleFavorite}
      className={styles.favoriteButton}
    >
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill={isFavorite ? FAVORITE_COLOR : "none"}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M1.91504 7.99997C0.227539 5.74997 0.790039 2.37497 3.60254 1.24997C6.41504 0.12497 8.10254 2.37497 8.66504 3.49997C9.22754 2.37497 11.4775 0.12497 14.29 1.24997C17.1025 2.37497 17.1025 5.74997 15.415 7.99997C13.7275 10.25 8.66504 14.75 8.66504 14.75C8.66504 14.75 3.60254 10.25 1.91504 7.99997Z"
          stroke={isFavorite ? FAVORITE_COLOR : "currentColor"}
          strokeWidth="1.125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className={styles.text}>{"Spremi"}</span>
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/ActionBar/FavoriteIcon.tsx